import React from "react";
import { Col, Row } from "antd";
import StartPanel from "./components/welcomePanel";
import TopCard from "./components/topCards/topCard";
import TopSellingProducts from "./TopSellingProducts/topSellingProducts";
import ShopbyCategory from "./ShopbyCategory/shopbyCategory";
import ProductReviews from "./ProductReviews/productReviews";
import RecentOrders from "./RecentOrders/recentOrders";
import Revenue from "./Revenue/Revenue";
import CustomerRating from "./CustomerRating/customerRating";
import PastTrends from "./PastTrends/pastTrends";

const DashBoard = () => {
  return (
    <div className="dashboard-content pt-8">
      <div className="container">
        <Row gutter={[12, 12]}>
          <Col className="gutter-row" xs={24}>
            <StartPanel />
          </Col>
        </Row>
        <TopCard />
        <div className="overview_grid mt-8">
          <h3 className="h3 font-weight-bolder mb-5">Overview</h3>
          <Row gutter={[12, 12]}>
            <Col className="gutter-row" xs={24} sm={12}>
              <TopSellingProducts />
            </Col>

            <Col className="gutter-row" xs={24} sm={12}>
              <PastTrends />
            </Col>
            <Col className="gutter-row" xs={24} sm={12}>
              <ProductReviews />
            </Col>
            <Col className="gutter-row" xs={24} sm={12}>
              <CustomerRating />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;
